export default "__VITE_ASSET__vla_$lT8__"